import { APIRoutes } from '../../routes';
import apiInstance from '../index';

export type EmailBrand = 'Triumph' | 'Chr' | 'ChrFinancial' | 'Rxo' | 'LoadPay';
export type EmailProduct = 'Factoring' | 'LoadPay' | 'TcsFuel';
export type PreviewSiteEnvironment = 'Current' | 'Dev' | 'Qa' | 'Prod';

export interface EmailTemplateCatalogItem {
    notificationType: string;
    name: string;
    subject: string;
    requiredProduct: EmailProduct;
    brands: EmailBrand[];
}

export interface EmailTemplateCatalog {
    templates: EmailTemplateCatalogItem[];
    brands: EmailBrand[];
    siteEnvironments: PreviewSiteEnvironment[];
}

export interface EmailTemplatePreviewRequest {
    notificationType: string;
    brand: EmailBrand;
    products: EmailProduct[];
    applicantId?: string;
    siteEnvironment: PreviewSiteEnvironment;
}

export interface EmailTemplatePreview {
    subject: string;
    from: string;
    body: string;
    mode: 'sample' | 'applicant';
    brandUsed: EmailBrand;
    productsUsed: EmailProduct[];
}

export async function getEmailTemplates(): Promise<EmailTemplateCatalog> {
    return (await apiInstance.get<EmailTemplateCatalog>(APIRoutes.EMAIL_TEMPLATES)).data;
}

export async function postEmailTemplatePreview(
    request: EmailTemplatePreviewRequest,
): Promise<EmailTemplatePreview> {
    return (await apiInstance.post<EmailTemplatePreview>(APIRoutes.EMAIL_TEMPLATES_PREVIEW, request)).data;
}
